import React from 'react';

import type { DateRef, Props } from './';
import DateInput from './';

const DateInputWithRef = React.memo(
  React.forwardRef((props: Props, ref: React.Ref<DateRef>) => (
    <DateInput {...props} innerRef={ref} />
  )),
);

export default DateInputWithRef;
